export function sortLegendKeys(keys: string[]): string[] {
    if (keys.length != 0) {
        if (keys[0].includes(' to ')) {
            keys = keys.sort(function(x,y){
                const xp = parseFloat(x.split(' ')[0]);
                const yp = parseFloat(y.split(' ')[0]);
                return xp == yp ? 0 : xp < yp ? -1 : 1;
            });
        }
    }

    return keys;
}

export const notRenderedKeysArray: string[] = [
    'labelFull', 'labelShort', 'labelSearch', 'labelName', 'key', 'dataLabel', 'interval', 'metricStart',
    'noOfDocs', 'tickValue', 'allDocs', 'relativeToAllDocs', 'singleNumber', 'comparableDocCount',
    // Technical fields that should not render as separate series
    'queryDuration',
    'labelFullComparable', 'labelShortComparable', 'labelSearchComparable', 'labelNameComparable',
];